export default "__VITE_ASSET__CQezwb4x__"